<template>
  <div
    @click="emitClickEvent(data.id)"
    class="window-element"
    :class="{
      'window-element-danger': type && type === 'danger',
      'window-element-success': type && type === 'success',
    }"
  >
    <div class="left-side">
      <div class="phone">{{ data.user_phone }}</div>
      <div class="user-name">{{ data.first_name }} {{ data.last_name }}</div>
      <div v-if="formattedDateWithTime" class="completetion-date">
        <p class="mt-2 mb-0" v-if="data.contact_time">
          K1: {{ formattedDateWithTime(data.contact_time) }}
        </p>
        <p class="mt-0 mb-0" v-if="data.second_contact_time">
          K2: {{ formattedDateWithTime(data.second_contact_time) }}
        </p>
      </div>
    </div>
    <div class="right-side">
      <div class="contact">
        {{
          data.contact_type === "PHONE"
            ? "Telefon"
            : data.contact_type === "SMS"
            ? "SMS"
            : "Brak"
        }}
      </div>
      <div class="days-till-order">
        {{ data.number_of_days_ago ? data.number_of_days_ago : 0 }}
      </div>
    </div>
  </div>
</template>

<script>
import shared from "../shared";
import moment from "moment";
export default {
  name: "UserProcessWindowElement",
  props: ["data", "type"],
  emits: ["click"],
  data() {
    return {
      formattedDateWithTime:null
    };
  },
  mounted() {
    this.formattedDateWithTime = shared.formattedDateAsNumbers;
  },
  methods: {
    getNow() {
      return this.formattedDateWithTime(moment().toDate());
    },
    emitClickEvent(id) {
      this.$emit("click", id);
    },
  },
};
</script>
<style scoped>
.window-element {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  gap: 8px;
  width: 292px;
  height: auto;
  margin: 8px 0;
  background: rgba(9, 7, 65, 0.02);
  border: 1px solid rgba(9, 7, 65, 0.25);
  border-radius: 5px;
  cursor: pointer;
}
.window-element-danger {
  background: rgba(9, 7, 65, 0.02);
  border: 1px solid #ec0909;
}
.window-element-success {
  background: rgba(14, 167, 84, 0.02);
  border: 1px solid #0ea754;
}
.window-element .phone {
  font-size: 16px;
  font-weight: 400;
}
.window-element .user-name {
  font-size: 12px;
  font-weight: 300;
  margin-top: -10px;
}
.window-element .completetion-date {
  font-size: 14px;
  font-weight: 300;
}
.window-element .clv {
  font-size: 16px;
  font-weight: 300;
}
.left-side {
  text-align: left;
}
.right-side {
  text-align: right;
}
.window-element .contact,
.window-element .days-till-order {
  font-size: 12px;
  font-weight: 300;
}
</style>
